// Escapes LIKE wildcards so ilike() can be used as a case-insensitive equality
// check (e.g. emails, where "_" is common and would otherwise match any character).
export function escapeLike(value) {
  return String(value).replace(/[\\%_]/g, '\\$&');
}
